import styled from "styled-components";
import Variables from "../../../../assets/styleVariables";

export const BoxLoadingContainer = styled.div`
  background-color: ${props =>
    props.size === "small" ? "" : Variables.colors.complementary};
  opacity: 0.7;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  height: 150px;
  .dot-flashing {
    position: relative;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite linear alternate;
    animation-delay: 0.5s;
  }

  .dot-flashing::before,
  .dot-flashing::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  .dot-flashing::before {
    width: 12px;
    height: 12px;
    left: calc(-1 * (12px + 8px));
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite alternate;
    animation-delay: 0s;
  }

  .dot-flashing::after {
    width: 12px;
    height: 12px;
    left: calc(12px + 8px);
    border-radius: 50%;
    background-color: ${Variables.colors.primary_400};
    color: ${Variables.colors.primary_400};
    animation: dotFlashing 0.8s infinite alternate;
    animation-delay: 0.8s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: ${Variables.colors.primary_400};
    }
    50%,
    100% {
      background-color: ${Variables.colors.primary_050};
    }
  }
`;
